// src/ui/screens/post/widgets/RecommendedUsersCard.jsx
//
// Full-width "Suggested channels" rail dropped into the Posted feed.
// Full width (rather than a single masonry column) so there's room for
// the horizontal row of people, the title, and the "See more" action.

import UserRecommendationItem from './UserRecommendationItem';

const BG = '#08090B';
const ORANGE = '#FF8C08';

export default function RecommendedUsersCard({ users, onSeeMore }) {
  if (!users || users.length === 0) return null;

  return (
    <div className="px-2.5 py-1.5 lg:px-8">
      <div
        className="rounded-xl p-3.5"
        style={{ backgroundColor: BG, border: '1px solid rgba(255,255,255,0.06)' }}
      >
        <div className="flex items-center">
          <span className="flex-1 text-white text-sm font-bold">Suggested channels</span>
          <button onClick={onSeeMore} className="flex items-center gap-0.5 shrink-0">
            <span style={{ color: ORANGE }} className="text-[13px] font-semibold">
              See more
            </span>
            <svg style={{ width: 16, height: 16, color: ORANGE }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* A fixed height (190px) used to sit here. Flex children default to
            align-items: stretch, so every UserRecommendationItem was stretched
            to that height, leaving a dead gap below the subscribe button.

            Dropping the fixed height and using items-start makes the row as
            tall as its tallest item, so the rail hugs the content. With only
            ~6 people in the rail there's no cost to rendering them all. */}
        <div
          className="mt-3 flex items-start gap-3 overflow-x-auto"
          style={{ scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch' }}
        >
          {users.map((user) => (
            <UserRecommendationItem key={user.id} user={user} />
          ))}
        </div>
      </div>
    </div>
  );
}

export { RecommendedUsersCard };